import { render } from "./BlogPostFormPage.vue?vue&type=template&id=f3405f22&ts=true"
import script from "./BlogPostFormPage.vue?vue&type=script&lang=ts"
export * from "./BlogPostFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__